import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'hooks';
import { DELETE_NOTIFICATION_SETTINGS } from '@control-front-end/common/constants/notifications';
import mes from 'globalIntl';

const useMutingMenu = (muteType, objId, deps = {}) => {
  const [isMutingOpened, toggleMenu] = useState(false);
  const [isMutedActor, setIsMutedActor] = useState(false);
  const t = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    if (deps?.actor) {
      setIsMutedActor(Boolean(deps?.actor.notificationSettings));
    }
  }, [deps?.actor]);

  useEffect(() => {
    const category = deps?.notificationDeps?.[muteType];
    if (category) {
      const curObject = category.find((item) => item.objId === objId);
      setIsMutedActor(Boolean(curObject));
    }
  }, [deps?.notificationDeps]);

  const processMuting = () => {
    if (!isMutedActor) {
      toggleMenu(true);
    } else {
      dispatch({
        type: DELETE_NOTIFICATION_SETTINGS.REQUEST,
        payload: { type: muteType, objId },
      });
    }
  };

  const closeMutingMenu = () => {
    toggleMenu(false);
  };
  const openMutingMenu = () => {
    toggleMenu(true);
  };

  const menuItemLabel = isMutedActor ? t(mes.unmute) : t(mes.muteNotifications);
  const menuItemImage = isMutedActor ? 'no_notification' : 'notification';

  return {
    isMutedActor,
    isMutingOpened,
    menuItemLabel,
    menuItemImage,
    processMuting,
    closeMutingMenu,
    openMutingMenu,
  };
};
export default useMutingMenu;
